<template>
  <div>
  <div class="spinner spinner--yellow">
    <div class="spinner__item1"></div>
    <div class="spinner__item2"></div>
    <div class="spinner__item3"></div>
  </div>
</div>
</template>
<script>
export default {
  name: 'loading'
}
</script>
<style>

.spinner {
  margin: 350px auto 0;
  width: 100px;
  text-align: center;
}

.spinner > div {
  width: 16px;
  height: 16px;
  background-color: #fff;
  border-radius: 100%;
  display: inline-block;
  animation: sk-bouncedelay 1.7s infinite ease-in-out both;
  margin-right: 5px;
}

.spinner--yellow > div {
  background: #E8E9EA;
}


.spinner .spinner__item1 {
  animation-delay: -0.60s;
}

.spinner .spinner__item2 {
  animation-delay: -0.40s;
}

.spinner .spinner__item3 {
  animation-delay: -0.20s;
}

@keyframes sk-bouncedelay {
  0%, 80%, 100% {
    transform: scale(0);
    opacity: 0;
  } 40% {
    transform: scale(1.0);
    opacity: 1;
  }
}
</style>



// WEBPACK FOOTER //
// Loading.vue?c66c62ce